// Simple unit-like tests for core utilities used in the app

export function testIcsExportFormat(): boolean {
  const lines: string[] = []
  lines.push('BEGIN:VCALENDAR')
  lines.push('VERSION:2.0')
  lines.push('PRODID:-//LittleEddieAudio//Calendar//EN')
  lines.push('BEGIN:VEVENT')
  lines.push('UID:le-1@littleeddieaudio.com')
  lines.push('DTSTAMP:20250101T000000Z')
  lines.push('DTSTART:20250101T000000Z')
  lines.push('SUMMARY:Test')
  lines.push('LOCATION:Test Venue')
  lines.push('DESCRIPTION:Test Desc')
  lines.push('END:VEVENT')
  lines.push('END:VCALENDAR')
  const out = lines.join('\r\n')
  return out.includes('BEGIN:VCALENDAR') && out.includes('BEGIN:VEVENT') && out.includes('END:VCALENDAR')
}

export function testCsvSplit(): boolean {
  const line = '"Acoustic, Night",The Cotillion,2025-07-18T20:00:00Z'
  const parts: string[] = []
  let current = ''
  let inQuotes = false
  for (let i = 0; i < line.length; i++) {
    const ch = line[i]
    if (ch === '"') {
      if (inQuotes && line[i + 1] === '"') { current += '"'; i++ } else { inQuotes = !inQuotes }
    } else if (ch === ',' && !inQuotes) { parts.push(current); current = '' }
    else { current += ch }
  }
  parts.push(current)
  return parts[0] === 'Acoustic, Night' && parts[1] === 'The Cotillion'
}

export function runAllTests(): { passed: number, failed: number, details: string[] } {
  const tests: Array<[string, () => boolean]> = [
    ['ICS export format', testIcsExportFormat],
    ['CSV split quoted', testCsvSplit],
  ]
  const details: string[] = []
  let passed = 0, failed = 0
  for (const [name, fn] of tests) {
    try {
      const ok = fn()
      if (ok) { passed++; details.push(`PASS: ${name}`) } else { failed++; details.push(`FAIL: ${name}`) }
    } catch (e) {
      failed++; details.push(`ERROR: ${name} ${(e as Error).message}`)
    }
  }
  return { passed, failed, details }
}


